import { CheckBoxWidget } from '@tableau/widgets';
import {HeaderColumn } from '@tableau/widgets-datagrid';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { ExplorerStyles } from '../../../components/Explorer/ExplorerStyles';

const headerStyle = style({
  marginLeft: CommonStyles.Sizes.MediumSpace,
});

export interface CheckboxHeaderOptions {
  onCheckboxClicked: () => void;
  isCheckboxSelected: boolean;
  isCheckboxDisabled: boolean;
  testId?: string;
}

export function CheckboxHeader(options: CheckboxHeaderOptions): React.Factory<HeaderColumn.HeaderFormatterProps> {
  return () => <CheckboxHeaderRenderer options={options} />;
}

// Module-scoped — stable identity prevents unmount/remount when columns rebuild.
function CheckboxHeaderRenderer({ options }: { options: CheckboxHeaderOptions }) {
  const handleClick: React.MouseEventHandler = event => {
    options.onCheckboxClicked();
    event.stopPropagation();
  };

  return (
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    <span
      onClick={handleClick}
      className={options.isCheckboxDisabled ? ExplorerStyles.CheckboxCellContainerDisabled : ExplorerStyles.CheckboxCellContainer}
      title={Messages.listViewCheckbox()}
    >
      <CheckBoxWidget
        testId={options.testId}
        checked={options.isCheckboxSelected}
        tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
        removeLeftMargin={true}
      />
    </span>
  );
}
